import { CustomerTypeEnum } from "@api/models/customer-type-enum";

export const CustomerTypeTranslations = {
  [CustomerTypeEnum.Annonsering]: 'global.customerTypes.advertising',
  [CustomerTypeEnum.Butik]: 'global.customerTypes.channel'
};
